<template>
<div class="w-full ">
  <div class="indicator_item">
    <div v-for="(item, index) in filteredFlowItem" :key="index" :style="{ width: `${100/flowItem.length}%`}" :class="isClass(index)">
      <i></i>
      <!-- <abbr></abbr> -->

      <span class="inline-flex pt-2 name-label text-xs sm:text-xs md:text-sm items-center capitalize">
        <img :src="icon(index)" class="mr-1"/>
        {{ item.name }}</span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ["index"],
  data() {
    return {
      isInterState: true,
      filteredFlowItem: [],
      flowItem: [
        {
          index: 1,
          name: "Sender & Reciever",
        },
        {
          index: 3,
          name: "package description",
        },
        {
          index: 4,
          name:  "Payment",
        },
        {
          index: 5,
          name: "Confirmation",
        },
      ],
    };
  },
  computed: {
    routeId() {
      return Number(this.$store.getters.getActiveTab) - 1;
    },
    shipping(){
      return  this.$store.getters.getBookingStates
    }
  },
  activated() {
    this.filteredFlowItem = this.flowItem
  },
  mounted(){
    this.filteredFlowItem = this.flowItem
  },
  watch: { 
    // "$store.getters.getBookingStates"(val){
    //   const shippingMethod = `${this.$store.getters.getBookingShippingMethod[0]}-to-${this.$store.getters.getBookingShippingMethod[1]}`;
    //   const checktype = (val.reciever === val.sender) && (shippingMethod !== "terminal-to-terminal")
    //   this.filteredFlowItem = this.flowItem
    //   checktype ? this.filteredFlowItem = this.flowItem.filter((item)=> item.name !== "Services") : this.filteredFlowItem = this.flowItem
    // }
  },
  methods: {
    icon(val){
      if (Number(this.routeId) > val) {
        return  require("../icons/progressCheck.svg")
      } else if (Number(this.routeId) == val) {
        return  require("../icons/progressActive.svg")
      } else if (Number(this.routeId) < val) {
        return  require("../icons/progressWaiting.svg")
      }
    },
    isClass(val) {
      let classes;
      if (Number(this.routeId) > val) {
        classes = "pass-flow-item ";
      } else if (Number(this.routeId) == val) {
        classes = "active-flow-item";
      } else if (Number(this.routeId) < val) {
        classes = "flow-item";
      }

      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
.indicator_item{
  @apply py-3 bg-primary-lightblue flex justify-center rounded-xl px-2 mb-3 pb-2;
}
.name-label {
  position: relative;
  left: 0;
}

.flow-item {
  position: relative;
  i {
    position: relative;
    display: block;
    width: 95%;
    height: 4px;
    border-radius: 50px;
    @apply bg-backgroundGrey2;
  }
}
.active-flow-item {
  position: relative;
  i {
    position: relative;
    display: block;
    width: 95%;
    height: 4px;
    border-radius: 50px;
    @apply bg-primary-yellow;
    transition: 300ms;
  }
}

.pass-flow-item {
  position: relative;
  i {
    position: relative;
    display: block;
    width: 95%;
    height: 4px;
    border-radius: 50px;
    @apply bg-primary-green;
    transition: 300ms;
  }
}

.flow-item:nth-last-child(1),
.active-flow-item:nth-last-child(1),
.pass-flow-item:nth-last-child(1) {
  width: 10px;
}
.min_item{
  min-width: 500px;
}
</style>
